import React from "react";
import { Send } from "lucide-react";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import api from "@/lib/api";

export default function ReminderButton({ client }) {
  async function handleClick() {
    if (!client?.email) {
      toast.error("Client has no email on file");
      return;
    }
    if (!client?.nextSession) {
      toast.error("No upcoming session date set");
      return;
    }
    try {
      await api.post(`/clients/${client.id}/send-reminder`, {});
      toast.success(`Reminder sent to ${client.email}`);
    } catch (err) {
      const detail = err?.response?.data?.detail || "Failed to send reminder";
      toast.error(typeof detail === "string" ? detail : "Failed to send reminder");
    }
  }

  return (
    <Button
      data-testid="send-reminder-btn"
      variant="outline"
      onClick={handleClick}
      className="rounded-2xl"
      title="Send a reminder email to the owner"
    >
      <Send size={16} className="mr-2" />
      Send Reminder
    </Button>
  );
}
